// Marketing landing page (logged-out visitors). Rewritten 2026-09-05 for the audience that
// actually signs up — beginners: no real money, a public score, learn from people with a
// track record. Serbian is the primary copy; the English keys are the translation.
export const landing: Record<string, string> = {
  'Signals': 'Signali',
  'Live': 'Live',
  'Traders': 'Trejderi',
  'Premium': 'Premium',
  'Create account': 'Napravi nalog',
  // Hero
  'Free · no real money': 'Besplatno · bez pravog novca',
  'Learn to trade without risking a dinar. With a score that can’t be faked.':
    'Nauči da trejduješ bez rizika. Sa skorom koji ne može da se lažira.',
  'Post a signal with an entry, a stop and a target on a simulated $10,000 account. The market closes it for you and you get an honest 0–100 score that shows exactly where you go wrong. Forex, gold, crypto — in Serbian.':
    'Objavi signal sa ulazom, stopom i ciljem na simuliranom nalogu od 10.000 $. Tržište ga samo zatvori, a ti dobiješ pošten skor od 0 do 100 koji pokazuje tačno gde grešiš. Forex, zlato, kripto — na srpskom.',
  'Create a free account': 'Napravi besplatan nalog',
  'See the signals': 'Pogledaj signale',
  'traders': 'trejdera',
  'published signals': 'objavljenih signala',
  'closed by the market': 'zatvorilo tržište',
  // Hero cards
  'EXAMPLE SIGNAL': 'PRIMER SIGNALA',
  'gold, 1-hour chart': 'zlato, satni grafikon',
  'HOW THE SCORE WORKS': 'KAKO RADI SKOR',
  'Entry, stop and target are locked the moment you publish.': 'Ulaz, stop i cilj se zaključavaju u trenutku objave.',
  'The market closes the signal — hit TP or hit SL, nothing else.': 'Signal zatvara tržište — pogođen TP ili pogođen SL, ništa drugo.',
  'Every closed signal moves your 0–100 score and the leaderboard.': 'Svaki zatvoren signal pomera tvoj skor 0–100 i rang listu.',
  // "Najnovije" strip (LatestStrip.tsx)
  'Latest on ShowMeTrade': 'Najnovije na ShowMeTrade',
  'Fresh from the community — right now, not last month.': 'Sveže iz zajednice — sada, ne prošlog meseca.',
  'Newest signal': 'Najnoviji signal',
  'Newest analysis': 'Najnovija analiza',
  'Newest forum topic': 'Najnovija tema na forumu',
  'HIT TP': 'TP POGOĐEN',
  'HIT SL': 'SL POGOĐEN',
  'See the feed': 'Pogledaj feed',
  '2h ago': 'pre 2 h',
  'OPEN': 'OTVOREN',
  'FROM THE FORUM': 'SA FORUMA',
  'replies': 'odgovora',
  // Feature cards
  'Practice without money': 'Vežbaj bez para',
  'A simulated $10,000 account, about 1% risk per signal, zero cost. A wrong call is a lesson, not a loss.':
    'Simulirani nalog od 10.000 $, oko 1% rizika po signalu, nula troška. Pogrešna procena je lekcija, ne gubitak.',
  'A score that doesn’t lie': 'Skor koji ne laže',
  'You can’t edit a signal after the fact and you can’t post a screenshot. The leaderboard measures skill — consistency, R:R, drawdown — not who made the most.':
    'Signal ne može da se prepravi naknadno, a screenshot se ne računa. Rang lista meri veštinu — konzistentnost, R:R, drawdown — a ne ko je najviše zaradio.',
  'Learn from people with a track record': 'Uči od onih sa rezultatom',
  'Follow traders whose score is public, ask on the forum in your own language. The Beginners section has no dumb questions.':
    'Prati trejdere čiji je skor javan, pitaj na forumu na svom jeziku. Sekcija „Početnici" nema glupih pitanja.',
  'Already have a track record? Open a premium channel and charge a subscription — the platform keeps only 10%.':
    'Već imaš rezultat? Otvori premium kanal i naplaćuj pretplatu — platforma zadržava samo 10%.',
  'Trading carries risk. This is not investment advice.': 'Trgovanje nosi rizik. Ovo nije investicioni savet.',
  'Terms': 'Uslovi',
  'Privacy': 'Privatnost',
  'Contact': 'Kontakt',
};
